export default __webpack_public_path__ + "static/media/home-background3.2670c4a6.png";